import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentProject } from "../../features/projects/state/projectsSlice";
import Navigation from "../../common/components/Navigation/Navigation";
import { useTranslation } from "react-i18next";
import AddTeamModal from "../../features/team/components/AddTeamModal";
import ParticipantCsv from "../../features/team/components/ParticipantFromCsvModal";
import { useEffect } from "react";
import { setAlert } from "../../features/alert/state/alertsSlice";
import OnboardingComponent from "../../common/util/OnBoardingComponent";
import stepsOnboarding from "../../common/util/OnboardingTour";
import { getIsLoading } from "src/features/graph/state/graphuSlice";
import ProjectPreview from "../../common/components/ProjectPreview/ProjectPreview";

const Main = () => {
  const currentProject = useSelector(getCurrentProject);
  if (!currentProject) return null;

  const isGraphLoading = useSelector(getIsLoading);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const modulePublished = currentProject.status !== "Edit";
  const steps = stepsOnboarding().onboardingHowToAddScene;
  const shouldShowOnboarding = !isGraphLoading;
  const pathArray = pathname.split("/").filter(Boolean);

  const isInNodeDetailsPage =
    pathArray[0] === "courses" && pathArray[4] === "graph" && pathArray[5] === "node";

  // Keep-Alive pattern: Unity WebGL preview stays mounted to prevent cleanup race condition
  // See Story 10.7 - GLctx error and keyboard hijacking when unmounting during load
  const lastUrlElement = pathArray[pathArray.length - 1];
  const isPreviewRoute = lastUrlElement === "preview";

  /* WIXAR-2588 : display an alert when project is published */
  useEffect(() => {
    if (modulePublished) {
      dispatch(
        setAlert({
          type: "warning",
          msg: t("alerts.publishedModule"),
          subMsg: t("alerts.publishedModuleAreNotEditable"),
          customTimeoutInMs: 2147483647,
          /* https://developer.mozilla.org/en-US/docs/Web/API/setTimeout#maximum_delay_value */
        }),
      );
    }
  }, []);

  const tabs = [
    { title: t("pages.project.tabs.scenario"), urlEndPoint: "graph" },
    { title: t("general.preview"), urlEndPoint: "preview" },
    { title: t("general.medias"), urlEndPoint: "medias" },
    { title: t("general.participants"), urlEndPoint: "learners" },
    { title: t("general.information"), urlEndPoint: "information" },
  ];
  const revelantArticleIsPublished = modulePublished ? "" : "howToAddScene";
  return (
    <>
      <Navigation
        title={currentProject.name}
        isProjectView
        showGoBackButton
        tabs={tabs}
        backCustomRedirectTo={
          isInNodeDetailsPage ? `/${pathArray.slice(0, 5).join("/")}` : undefined
        }
      />
      {shouldShowOnboarding && (
        <OnboardingComponent
          id={revelantArticleIsPublished}
          relevantArticle={revelantArticleIsPublished}
          steps={steps}
        />
      )}
      {/* Keep-Alive: Unity WebGL preview stays mounted but hidden when not active */}
      <div
        className={isPreviewRoute ? "h-full" : "hidden"}
        aria-hidden={!isPreviewRoute}
      >
        <ProjectPreview />
      </div>
      {/* Outlet renders when not on preview route */}
      <div className={isPreviewRoute ? "hidden" : ""}>
        <Outlet />
      </div>
      <AddTeamModal />
      <ParticipantCsv />
    </>
  );
};

export default Main;
